import { acceleratedRaycast } from "three-mesh-bvh";
import * as THREE from "three";
THREE.Mesh.prototype.raycast = acceleratedRaycast;
const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();
let objects = [];
let scene;
export function initRaycaster(pScene) {
    scene = pScene;
    objects.forEach((oName, i) => (objects[i] = scene.getObjectByName(oName)));
    container3D.addEventListener("pointermove", onPointerMove);
    container3D.addEventListener("pointerdown", onClick);
}
function onPointerMove(event) {
    const rect = container3D.getBoundingClientRect();
    pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
    const intersects = getIntersects();
    if (!intersects) return;
    servObj.onHover3D.forEach((callback) => callback(intersects));
}
function onClick(event) {
    const rect = container3D.getBoundingClientRect();
    pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
    const intersects = getIntersects();
    if (!intersects) return;
    servObj.onClick3D.forEach((callback) => callback(intersects));
}
function getIntersects() {
    const camera = scene.activeCamera;
    raycaster.setFromCamera(pointer, camera);
    const intersects = raycaster.intersectObjects(objects);
    return intersects;
}
export function setIntersectsObjects(objs) {
    objects = objs;
}
export function getIntersectsObjects() {}
